import React, { useEffect, useState } from "react";
import ReferralHistoryDesktop from "./ReferralHistoryDesktop";
import ReferralHistoryMobile from "./ReferralHistoryMob";
import { useNavigate } from 'react-router-dom';
function useIsDesktop(breakpoint = 768) {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= breakpoint : false
  );
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia(`(min-width: ${breakpoint}px)`);
    const onChange = () => setIsDesktop(mq.matches);
    mq.addEventListener?.("change", onChange);
    onChange();
    return () => mq.removeEventListener?.("change", onChange);
  }, [breakpoint]);
  return isDesktop;
}

export default function ReferralHistoryComponent() {
  const isDesktop = useIsDesktop();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isDesktop) setOpen(false);
  }, [isDesktop]);
 const navigate = useNavigate();
  return (
    <div className="flex justify-end " >
     
          {/* <button
            onClick={() => navigate('/referralhistory')}
            className="bg-accent ms-0 ms-lg-2 p-3 rounded-xl text-white md:w-1/5" style={{width:'100%'}}
          >
            Transaction History
          </button> */}
     

      {isDesktop ? (
        <ReferralHistoryDesktop total={0} open={open} onClose={() => setOpen(false)} />
      ) : (
        <ReferralHistoryMobile total={0} open={open} onClose={() => setOpen(false)} />
      )}
    </div>
  );
}
